// WCAG 1.4.10 support — in the stacked (small-screen / high-zoom) table view, the
// wide column-header grid is hidden, so a sighted user can no longer tell which column
// a cell belongs to. Copy each column's visible name onto its data cells as a
// `data-label`, which the stacked-table CSS shows above the cell.
//
// The column name lives on the sticky-header cells (`.sticky-header__cell[data-asset-type]`
// -> visible text); a header may cover several asset types (space-separated). Body cells
// carry a single `data-asset-type`, so the mapping is by asset type — which is
// order-independent and reads whatever the header actually says (including Spanish).

const applyStackedTableLabels = () => {
  const labelByAssetType = {}

  document
    .querySelectorAll(".sticky-header__cell[data-asset-type]")
    .forEach(headerCell => {
      const text = (headerCell.textContent || "").trim()
      if (!text) {
        return
      }
      headerCell
        .getAttribute("data-asset-type")
        .split(/\s+/)
        .forEach(assetType => {
          if (assetType) {
            labelByAssetType[assetType] = text
          }
        })
    })

  document.querySelectorAll(".table__cell[data-asset-type]").forEach(cell => {
    const assetType = cell.getAttribute("data-asset-type")
    if (assetType && labelByAssetType[assetType]) {
      cell.setAttribute("data-label", labelByAssetType[assetType])
    }
  })
}

const init = () => {
  applyStackedTableLabels()
}

export default { init, applyStackedTableLabels }
